export const APP_PATHS = {
  BASE: '/',
  GRAMMAR: '/gramatica',
  LITERATURE: '/literatura',
}
